<template>
    <div v-if="answers && !answers['title'] &&  !answers.hasOwnProperty('valid')">
        <span @click="resetProgress(position)"
              v-if="answers.name"
              :class="{'father-title':!this.fatherIndex,'children-title': this.fatherIndex}">{{answers.name}}</span>
        <div :key="index" v-for="(item,index) in answers">
            <div :class="{'father-container': isRoot && item.name && !item.hasOwnProperty('valid'),'common-container': true}"
                 v-if="!isNaN(index * 1)">
                <!--<span @click="resetProgress(answers.pos)" v-if="isRoot && item.name && !item.hasOwnProperty('valid')"-->
                <!--class="father-title">{{item.name}}{{position}}</span>-->
                <question-tree :fatherIndex="position" :fatherAnswers="answers" :currentIndex="index"
                               :answers="answers[index*1]"></question-tree>
            </div>
        </div>
    </div>
    <div :class="{'answer-container':true}"
         v-else-if="answers && answers['title'] && !answers.hasOwnProperty('valid') ">
        <div @click="resetProgress(position)" class="title">{{answers['title']}}</div>
        <div class="answer" :key="index" v-for="(item,index) in answers['datas']">
            <div @click="resetProgress(position)">
                <p style="word-wrap: break-word">
                    {{item.hasOwnProperty('label') ? item.label : answerHandler(item.answer)}}
                </p>
                <p style="word-wrap: break-word">
                    {{item.input}}
                </p>
            </div>
            <div v-if="item.upload && item.upload.url">
                {{getUploadUrl(item.upload)}}
                <van-image
                        @click="clickPicHandler($event,ind)"
                        v-for="(it,ind) in picList"
                        :key="ind"
                        width=".5rem"
                        height=".5rem"
                        :src="it"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import questionTree from './question-tree'
    import {EventBus} from './event-bus'
    import Vue from 'vue';
    import {Image as VanImage, ImagePreview} from 'vant';

    Vue.use(VanImage).use(ImagePreview);
    export default {
        name: "question-tree",
        props: {
            answers: {
                required: true
            },
            currentIndex: {
                required: false
            },
            fatherAnswers: {
                required: false
            },
            fatherIndex: {
                required: false
            },
        },
        data() {
            return {
                picList: []
            }
        },
        components: {
            questionTree
        },
        computed: {
            position() {
                if (this.fatherIndex) {
                    return `${this.fatherIndex},${this.currentIndex}`
                } else {
                    return this.currentIndex
                }
            },
            isRoot() {
                return !this.fatherIndex;
            }

        },
        mounted() {

        },
        methods: {
            clickPicHandler(event, index) {
                ImagePreview({
                    images: this.picList,
                    startPosition: index
                })
            },
            resetProgress(index) {
                if (index) {
                    EventBus.$emit('resetProgress', index)
                }
            },
            getUploadUrl(upload) {
                if (upload.type === 'pic') {
                    if (upload.url.indexOf(',') != -1) {
                        this.picList = upload.url.split(',')
                    } else {
                        this.picList = [upload.url]
                    }
                }
                return ''
            },
            /**
             * 用来处理展示的时间 如果是数字格式直接防护 不是的话处理
             * @param answer
             * @return {*}
             */
            answerHandler(answer) {
                if (answer) {
                    if (answer.indexOf(':') !== -1) {
                        let arr = answer.split(':')
                        console.log(arr);
                        return arr.reduce((result, item, index) => {
                            let str = index > 0 ? (':' + this.timeHandlerWith_(item)) : this.timeHandlerWith_(item)
                            return result + str
                        }, '')
                    } else if (answer.indexOf('-') !== -1) {
                        //判断是否是日期格式
                        return this.timeHandlerWith_(answer)
                    } else {
                        return answer
                    }
                } else {
                    return ''
                }
            },
            timeHandlerWith_(answer) {
                let arr = answer.split('-');
                //分割日期
                return arr.reduce((result, item, index) => {
                    //将日期对应的转化成展示的格式
                    let str = index > 0 ? ('-' + this.timeHandler(item)) : this.timeHandler(item);
                    return result + str
                }, '')
            },
            /**
             * 用来处理展示的时间
             * @param time
             * @returns {*}
             * x: 不清楚 a: 上半年 b: 下半年
             */
            timeHandler(time) {
                if (time === 'x') {
                    return '不清楚'
                } else if (time === 'a') {
                    return '上半年'
                } else if (time === 'b') {
                    return '下半年'
                } else {
                    return time
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    * {
        box-sizing: border-box;
    }

    .common-container {
    }

    .is-border {
        border-bottom: 1px dashed #ccc;
    }

    .father-title {
        cursor: pointer;
        width: 100%;
        font-size: .16rem;
        color: #000;
        display: block;
        text-align: left;
        border-left: 6px solid #248cfa;
        padding-left: .2rem;
        font-weight: 700;
    }

    .children-title {
        cursor: pointer;
        width: 100%;
        font-size: .16rem;
        color: #000;
        background-color: #F5F5F5;
        padding: .15rem;
        display: block;
        text-align: left;
        font-weight: 700;
        border-radius: .06rem;
    }

    .father-container {
        margin-bottom: .1rem;
        padding-left: .1rem;

    }

    .answer-container {
        text-align: left;
        padding: .16rem .24rem;
        cursor: pointer;

        .title {
            font-size: .14rem;
            margin-bottom: .1rem;
        }

        .answer {
            color: #248cfa;
            font-size: .14rem;

            .error {
                color: red;
            }
        }
    }
</style>